import { styled } from '@mui/system';
import { motion } from 'framer-motion';
import { Hex1 } from './Hex1';
import { Hex2 } from './Hex2';
import { Hex3 } from './Hex3';
import { Hex4 } from './Hex4';

const Positionator = styled(motion.div)(({ theme }) => ({
  position: 'relative',
  zIndex: 1
}));

export const Decorator1 = () => {
  return (
    <Positionator
      sx={{
        left: {
          xl: '-10%',
          lg: '-10%',
          md: '-6%',
          sm: '-5%',
          xs: '-5%'
        },
        top: {
          xl: '-4.5em',
          lg: '-4.5em',
          md: '-4.5em',
          sm: '-2em',
          xs: '-2em'
        }
      }}
    >
      <Hex1
        sx={{
          width: {
            xl: '123px',
            lg: '123px',
            md: '123px',
            sm: '60px',
            xs: '60px'
          },
          height: {
            xl: '141px',
            sl: '141px',
            md: '141px',
            sm: '70px',
            xs: '70px'
          }
        }}
      />
    </Positionator>
  );
};
export const Decorator2 = () => {
  return (
    <>
      <Positionator
        sx={{
          left: {
            xl: '90%',
            lg: '90%',
            md: '90%',
            sm: '90%',
            xs: '90%'
          },
          top: {
            xl: '3em',
            lg: '3em',
            md: '-61em',
            sm: '-33em',
            xs: '-33em'
          }
        }}
      >
        <Hex2
          sx={{
            width: {
              xl: '123px',
              lg: '123px',
              md: '123px',
              sm: '60px',
              xs: '60px'
            },
            height: {
              xl: '141px',
              sl: '141px',
              md: '141px',
              sm: '70px',
              xs: '70px'
            }
          }}
        />
      </Positionator>
      <Positionator
        sx={{
          display: {
            xl: 'none',
            lg: 'none'
          },
          left: {
            md: '93%',
            sm: '90%',
            xs: '90%'
          },
          top: {
            md: '-15.5em',
            sm: '-6.5em',
            xs: '-6.5em'
          }
        }}
      >
        <Hex1
          sx={{
            width: {
              xl: '123px',
              lg: '123px',
              md: '123px',
              sm: '60px',
              xs: '60px'
            },
            height: {
              xl: '141px',
              sl: '141px',
              md: '141px',
              sm: '70px',
              xs: '70px'
            }
          }}
        />
      </Positionator>
    </>
  );
};
export const Decorator3 = () => {
  return (
    <Positionator
      sx={{
        left: {
          xl: '-6%',
          lg: '-6%',
          md: '-4%',
          sm: '-6%',
          xs: '-6%'
        },
        top: {
          xl: '-2.5em',
          lg: '-2.5em',
          md: '-4.5em',
          sm: '-2.5em',
          xs: '-2.5em'
        }
      }}
    >
      <Hex3
        sx={{
          width: {
            xl: '89px',
            lg: '89px',
            md: '89px',
            sm: '60px',
            xs: '60px'
          },
          height: {
            xl: '77px',
            sl: '77px',
            md: '77px',
            sm: '70px',
            xs: '70px'
          }
        }}
      />
    </Positionator>
  );
};
export const Decorator4 = () => {
  return (
    <Positionator
      sx={{
        left: {
          xl: '85%',
          lg: '85%',
          md: '95%',
          sm: '95%',
          xs: '95%'
        },
        top: {
          xl: '-4em',
          lg: '-4em',
          md: '-4em',
          sm: '-2.5em',
          xs: '-2.5em'
        }
      }}
    >
      <Hex4
        sx={{
          width: {
            xl: '168px',
            lg: '168px',
            md: '100px',
            sm: '60px',
            xs: '60px'
          },
          height: {
            xl: '191px',
            sl: '191px',
            md: '120px',
            sm: '70px',
            xs: '70px'
          }
        }}
      />
    </Positionator>
  );
};
